import { lazy, ReactElement, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { LoadingSpinner } from '../../components/shared/LoadingSpinner'

const BudgetBuilder = lazy(() => import('./BudgetBuilder'))

export function BudgetRoutes(): ReactElement {
  return (
    <Suspense fallback={<LoadingSpinner isLoading={true} label="Loading..." />}>
      <Routes>
        <Route path="/*" element={<BudgetBuilder />} />
      </Routes>
    </Suspense>
  )
}
